enum ChannelView {
    Classic,
    Dial
}

export default ChannelView
